const template = document.createElement('template')
template.innerHTML = `
<style>

::slotted(ul) {
	display: none;
}

* {
	// box-sizing: border-box;
}

.list {
	overflow-y: auto;
	display: flex;
	flex-direction: column;
}

a {
	cursor: pointer;
	transform: scale3d(1, 1, 1);
	opacity: 0;
  padding: 0.4em 0;
}

a:hover svg {
  fill: black !important;
  stroke: white !important;
  transform: scale(1.4);
  color: #fff;
}

.parent a.in {
	animation: back-in .2s linear forwards;
}

.parent a.out {
	animation: back-out .2s linear forwards;
}

.list a {
	animation: menu .3s calc(var(--index) * 0.05s + 0.1s) ease-out forwards;
}

@keyframes menu {
	0% {
		transform: translateY(-10px);
		opacity: 0;
	}

	100% {
		transform: translateY(0);
		opacity: 1;
	}
}

@keyframes back-in {
	0% {
		transform: translateX(-10px);
		opacity: 0;
	}

	100% {
		transform: translateX(0);
		opacity: 1;
	}
}

@keyframes back-out {
	0% {
		transform: translateX(10px);
		opacity: 0;
	}

	100% {
		transform: translateX(0);
		opacity: 1;
	}
}

.push p{
  margin: 0;
}
.push a{
  display: block;
  width: 1.375rem;
  height: 1.375rem;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath d='M10 .75A9.225 9.225 0 0 1 19.25 10 9.225 9.225 0 0 1 10 19.25 9.225 9.225 0 0 1 .75 10 9.225 9.225 0 0 1 10 .75Z' stroke='%23000' fill='%23fff' stroke-width='1.5'/%3E%3Cpath d='M12.97 10.463H6.066M9.61 6.54l3.812 3.813-3.813 3.813' fill='none' stroke='%23000'/%3E%3C/svg%3E") no-repeat right center;
  
  background-size: 100%;
  text-indent: -999rem;
  overflow: hidden;
  border-radius: 50%;
  opacity: 1;
  padding: 0;
  flex: 0 0 auto;
}
</style>

<div class="source"><slot></slot></div>

<div class="wrapper" part="wrapper">
	<div class="parent" part="parent"></div>
	<div class="list" part="list"></div>
	<div class="push" part="push"></div>
</div>

<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: none;">
<symbol id="icon-submenu-link" viewBox="0 0 20 20"><path d="M10 .75A9.225 9.225 0 0 1 19.25 10 9.225 9.225 0 0 1 10 19.25 9.225 9.225 0 0 1 .75 10 9.225 9.225 0 0 1 10 .75Z" stroke="#000" stroke-width="1.5"/><path d="M12.97 10.463H6.066M9.61 6.54l3.812 3.813-3.813 3.813" stroke="currentColor"/></symbol>
</svg>
`

const iconForward =
  '<svg class="svg" aria-hidden="true" part="icon forward"><use xlink:href="#icon-submenu-link"></use></svg>'
const iconBack =
  '<svg class="svg" aria-hidden="true" part="icon back"><use xlink:href="#icon-submenu-link"></use></svg>'

customElements.define(
  'vp-menu',
  class extends HTMLElement {
    constructor() {
      super()

      this.connected = false

      this.attachShadow({ mode: 'open' })
      const clone = template.content.cloneNode(true)
      this.shadowRoot.appendChild(clone)

      this.dom = {}
      this.dom.ul = this.querySelector(':scope > ul')
      this.dom.wrapper = this.shadowRoot.querySelector('.wrapper')
      this.dom.parent = this.dom.wrapper.querySelector(':scope > .parent')
      this.dom.list = this.dom.wrapper.querySelector(':scope > .list')
      this.dom.push = this.dom.wrapper.querySelector(':scope > .push')

      this.data = {}
      this.root = this.parse(this.dom.ul)

      this.pushNotif = this.querySelector(':scope .push-notif')

      // console.log(this.data, this.root)

      this.dom.wrapper.addEventListener('click', (e) => {
        const target = e.target.closest('[data-menu]')
        if (!target) return
        const back = target.parentNode.classList.contains('parent')
        this.set(target.dataset.menu, back)
      })

      this.set(this.root)

      handlePushNotif(this.dom.push)
    }

    // connectedCallback() {
    // 	this.connected = true
    // }

    // attributeChangedCallback(name, oldValue, newValue) {
    //   if (this.connected) {
    //     // console.log(`L'attribut ${name} à changé de valeur de ${oldValue} à ${newValue}`);
    //     switch (name) {
    //       case 'gutter':
    //         const gutter = parseInt(newValue || 0, 10);
    //         this.shadowRoot.querySelector('.list').style.gap = `${parseInt(newValue || 0, 10)}px`;
    //         break;
    //       case 'controls':
    //         break;
    //     }
    //   }
    // }

    // return an array of all elements
    // elements() {
    // 	const slot = this.dom.list.querySelector(':scope > slot')
    // 	return slot.assignedNodes()
    // }

    parse(ul, parent = null) {
      const id = '_' + Math.random().toString(16).substring(2, 9)
      const o = { parent }
      o.items = []
      const lis = ul.querySelectorAll(':scope > li')
      if (lis.length > 0) {
        for (const li of lis) {
          const a = li.querySelector(':scope > a')
          if (a) {
            const text = a.textContent
            const link = a.getAttribute('href')
            const target = a.getAttribute('target') || '_self'
            const sub = li.querySelector(':scope > div > ul')
            const menu = sub ? this.parse(sub, { menu: id, text }) : null
            o.items.push({ text, link, target, menu })
          }
        }
      }
      this.data[id] = o
      return id
    }

    set(id, back) {
      this.dom.parent.innerHTML = ''
      this.dom.list.innerHTML = ''
      const o = this.data[id]
      let root
      if (o) {
        if (o.parent) {
          root = o.parent.menu === this.root
          this.dom.parent.innerHTML = this.link(o.parent, null, back, root)
        }
        if (o.items.length > 0) {
          root = id === this.root
          for (const [key, item] of Object.entries(o.items)) {
            this.dom.list.innerHTML += this.link(item, key, back, root)
          }
        }
      }

      if(this.pushNotif){
        this.dom.push.innerHTML = this.pushNotif.innerHTML;
      }
    }

    link(o, key, back = false, root = false) {
      const hasMenu = !!o.menu
      const hasLink = !hasMenu && !!o.link
      const hasKey = !!key
      let before = ''
      let after = ''

      const parts = ['item']
      if (root) parts.push('is-root')
      if (hasKey) {
        parts.push('list-item')
        if (hasLink) parts.push('has-link')
        if (hasMenu) {
          parts.push('has-menu')
          after = iconForward
        }
      } else {
        parts.push('back-item')
        before = iconBack
      }
      const classes = ` class="${back ? 'out' : 'in'}"`

      const menu = hasMenu ? ` data-menu="${o.menu}"` : ''
      const link = hasLink ? ` href="${o.link}"` : ''
      const target = ` target="${o.target}"`
      const part = ` part="${parts.join(' ')}"`
      const style = hasKey ? ` style="--index:${key}"` : ''

      return `<a${part}${style}${link}${target}${menu}${classes}>${before}${o.text}${after}</a>`
    }
  },
  { extends: 'nav' },
)

function handlePushNotif(el) {
  let link = el.querySelector('a');
  if(!link) return;

  el.style.cursor = 'pointer';
  el.addEventListener('click', ev => {
    window.location.href = link.getAttribute('href');
  });
}

document.querySelectorAll('.m-menu-primary .push-notif').forEach(el => {
  handlePushNotif(el);
});